import type { Classroom } from './classroom';
import type { ClassroomType } from './classroom-type';

const filterClassroomsByType = (
  classrooms: Classroom[],
  type?: ClassroomType
): Classroom[] => {
  if (!type) {
    return classrooms;
  }

  return classrooms.filter((classroom) => classroom.type === type);
};

const sortClassroomsByName = (classrooms: Classroom[]): Classroom[] => {
  return [...classrooms].sort((a, b) => a.name.localeCompare(b.name));
};

const filterAndSortClassrooms = (
  classrooms: Classroom[],
  type?: ClassroomType
): Classroom[] => {
  return sortClassroomsByName(filterClassroomsByType(classrooms, type));
};

export { filterAndSortClassrooms };
